var exports = {
  "kL": "x234b8571--94832f--container",
  "Sl": "x234b8571--94832f--image",
  "Qs": "x234b8571--94832f--content",
  "DD": "x234b8571--94832f--title",
};

module.exports = exports;
